// 兼容代码-----------
import 'antd/es/table/style';
import 'antd/es/alert/style'; //----------------------

import { FieldIndexColumn, FieldStatus } from '@ant-design/pro-field';
import { arEGIntl, caESIntl, ConfigConsumer, ConfigProvider, ConfigProviderWrap, createIntl, enUSIntl, esESIntl, frFRIntl, itITIntl, jaJPIntl, msMYIntl, ptBRIntl, ruRUIntl, viVNIntl, zhCNIntl, zhTWIntl } from '@ant-design/pro-provider';
import DragSortTable from './components/DragSortTable';
import TableDropdown from './components/Dropdown';
import EditableProTable from './components/EditableTable';
import Search from './components/Form';
import ListToolBar from './components/ListToolBar';
import ProTable from './Table';
export { ConfigProviderWrap, TableDropdown, ListToolBar, FieldStatus as TableStatus, Search, EditableProTable, DragSortTable, ConfigProvider as IntlProvider, ConfigProvider, ConfigConsumer as IntlConsumer, ConfigConsumer, zhCNIntl, FieldIndexColumn as IndexColumn, createIntl, arEGIntl, enUSIntl, viVNIntl, itITIntl, jaJPIntl, esESIntl, caESIntl, ruRUIntl, msMYIntl, zhTWIntl, frFRIntl, ptBRIntl, ProTable };
export default ProTable;